module.exports = __webpack_public_path__ + "media/images/index-cover-ff7c9276b2527f38a5437f9a47e2b05f.jpg";